import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FinancialPositionListComponent } from './components/financial-position-list/financial-position-list.component';
import {FinancialPositionsRoutingModule} from "./financial-positions-routing.module";
import { CreateFinancialPositionComponent } from './components/create-financial-position/create-financial-position.component';
import { EditFinancialPositionComponent } from './components/edit-financial-position/edit-financial-position.component';
import { FinancialPositionFormComponent } from './components/financial-position-form/financial-position-form.component';
import { AssetTableComponent } from './components/asset-table/asset-table.component';
import { ViewFinancialPositionComponent } from './components/view-financial-position/view-financial-position.component';
import { FinancialPositionLandingComponent } from './components/financial-position-landing/financial-position-landing.component';
import { ProposeChangesComponent } from './components/propose-changes/propose-changes.component';
import { FinancialPositionGraphComponent } from './components/financial-position-graph/financial-position-graph.component';
import { PositionsOverTimeGraphComponent } from './components/positions-over-time-graph/positions-over-time-graph.component';
import {TandemCoreModule} from "../tandem-core/tandem-core.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { AssetDialogComponent } from './components/asset-dialog/asset-dialog.component';
import {LiabilityTableComponent} from "./components/liability-table/liability-table.component";
import {LiabilityDialogComponent} from "./components/liability-dialog/liability-dialog.component";
import {NgxChartsModule} from "@swimlane/ngx-charts";
import {NgxEchartsModule} from "ngx-echarts";
import { CreateGoalFromPcFormComponent } from './components/create-goal-from-pc-form/create-goal-from-pc-form.component';
import {TandemDatePipe} from "../tandem-core/directives/tandem-date.pipe";
import { PcDisclosureComponent } from './components/propose-changes/pc-disclosure/pc-disclosure.component';
import {NgxMaskDirective} from "ngx-mask";



@NgModule({
    declarations: [
        FinancialPositionListComponent,
        CreateFinancialPositionComponent,
        EditFinancialPositionComponent,
        FinancialPositionFormComponent,
        AssetTableComponent,
        LiabilityTableComponent,
        ViewFinancialPositionComponent,
        FinancialPositionLandingComponent,
        ProposeChangesComponent,
        FinancialPositionGraphComponent,
        PositionsOverTimeGraphComponent,
        AssetDialogComponent,
        LiabilityDialogComponent,
        CreateGoalFromPcFormComponent,
        PcDisclosureComponent
    ],
    exports: [
        FinancialPositionGraphComponent,
        FinancialPositionListComponent
    ],
    imports: [
        CommonModule,
        FinancialPositionsRoutingModule,
        TandemCoreModule,
        ReactiveFormsModule,
        NgxChartsModule,
        NgxEchartsModule,
        FormsModule,
        NgxMaskDirective,
    ],
  providers: [
    TandemDatePipe
  ]
})
export class FinancialPositionsModule { }
